import { createContext, useContext } from "react";

export const FiltroEsatadoContext = createContext({});

export const useFiltroEstadoContext = () => {
  return useContext(FiltroEsatadoContext);
};
